import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Vishrantwaditomuumbaicab() {



const cardData = {
  keyword: " Vishrantwadi to Mumbai Cab  ",

"headingDescription": "SRS Cab Service offers Vishrantwadi to Mumbai Cab, providing a safe, comfortable, and reliable travel solution for business travelers, corporate clients, and leisure passengers. Our well-maintained vehicles, professional drivers, and timely pickups ensure a smooth journey from Vishrantwadi to Mumbai. Ideal for airport transfers, corporate trips, weekend getaways, and personal travel, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a hassle-free and enjoyable ride.",
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Gateway of India is Mumbai’s iconic landmark overlooking the Arabian Sea. Travelers using Vishrantwadi to Mumbai Cab from SRS Cab Service often visit this historic site for sightseeing and photography."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive is a famous seaside promenade known for breathtaking sunset views. Visitors using SRS Cab Service often enjoy leisurely walks along this picturesque coastline."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves are UNESCO-listed rock-cut caves located on an island near Mumbai. Travelers using SRS Cab Service often include this destination for historical and cultural exploration."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus",
    "description": "This historic railway station features Victorian Gothic architecture. Visitors using SRS Cab Service often admire its grandeur and heritage significance."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is a lively coastal destination known for street food and leisure activities. Travelers using SRS Cab Service often visit to enjoy sunsets and local cuisine."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple is a renowned temple dedicated to Lord Ganesha. Visitors using SRS Cab Service often seek blessings and spiritual serenity."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a revered mosque on an islet in the Arabian Sea. Travelers using SRS Cab Service often visit for spiritual significance and scenic beauty."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a bustling street in Mumbai known for shopping and cultural experiences. Travelers using SRS Cab Service often explore this area for dining and local souvenirs."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is a large green space offering wildlife, trekking, and nature activities. Visitors using SRS Cab Service often enjoy outdoor recreation here."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "Bandra-Worli Sea Link is an iconic bridge connecting major areas of Mumbai. Travelers using SRS Cab Service often take this route for scenic views and a smooth drive."
  }
],



services: [
{
name: "Vishrantwadi to Mumbai Cab Price",
description: "Vishrantwadi to Mumbai cab price provides estimated cost for intercity travel. Customers can compare fares before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe expressway journeys. Comfortable vehicles enhance experience. Travel easily with cab price services."
},
{
name: "Dhanori to Mumbai Cab Service",
description: "Dhanori to Mumbai cab service offers reliable transportation for long-distance journeys. Customers can book cabs for flexible trips. Professional drivers ensure safe expressway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Vishrantwadi to Mumbai Airport Cab",
description: "Vishrantwadi to Mumbai airport cab provides convenient transfer for passengers. Customers can book cabs for timely airport drop. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Vishrantwadi to Dadar Cab",
description: "Vishrantwadi to Dadar cab offers reliable travel for central Mumbai routes. Customers can book cabs for flexible journeys. Professional drivers ensure safe expressway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Mumbai to Vishrantwadi Cab",
description: "Mumbai to Vishrantwadi cab provides convenient return travel for customers. Users can book cabs for intercity journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Bhosari to Mumbai Cabs",
description: "Bhosari to Mumbai cabs offer dependable intercity travel for customers. Users can book cabs for business and personal trips. Professional drivers ensure safe expressway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Bhosari to Mumbai Cab Service",
description: "Bhosari to Mumbai cab service provides reliable transportation for long-distance travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Cab Service in Dhanori",
description: "Cab service in Dhanori offers reliable transportation for local and outstation travel. Customers can book cabs for daily and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Cab Service in Vishrantwadi",
description: "Cab service in Vishrantwadi provides dependable travel for city and intercity routes. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service in Vishrantwadi",
description: "Taxi service in Vishrantwadi offers convenient transportation for local and airport routes. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Innova Crysta on Rent in Vishrantwadi",
description: "Innova Crysta on rent in Vishrantwadi offers premium SUV travel for comfort and luxury. Customers can enjoy spacious seating and smooth rides. Professional drivers ensure safe journeys. Ideal for family and corporate travel. Transparent pricing ensures value. Travel easily with Innova Crysta services."
},
{
name: "Innova Crysta Hire in Bhosari",
description: "Innova Crysta hire in Bhosari provides luxury SUV travel for long-distance trips. Customers can enjoy premium seating and comfort. Professional drivers ensure safe journeys. Ideal for family and corporate travel. Transparent pricing ensures value. Travel easily with Innova Crysta services."
},
{
name: "Ertiga on Rent in Vishrantwadi",
description: "Ertiga on rent in Vishrantwadi offers comfortable 7 seater travel for families and groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga services."
},
{
name: "Sedan Car on Rent in Bhosari",
description: "Sedan car on rent in Bhosari provides affordable travel for local and outstation trips. Customers can book vehicles for comfortable journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan services."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune provides dependable transportation for city and intercity travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai airport cab offers reliable transfer services for passengers. Customers can book cabs for timely airport drop. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Pune Mumbai Cab",
description: "Pune Mumbai cab provides reliable intercity transportation for customers. Users can book cabs for business and personal trips. Professional drivers ensure safe expressway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Tingre Nagar to Mumbai Cabs",
description: "Tingre Nagar to Mumbai cabs offer convenient intercity travel for customers. Users can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Charholi to Mumbai Cab Service",
description: "Charholi to Mumbai cab service provides reliable transportation for long-distance travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe expressway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Cab Service in Vishrantwadi Pune",
description: "Cab service in Vishrantwadi Pune offers reliable travel solutions for local and outstation trips. Customers can book cabs for daily and business use. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
}
],

tableData: [
["Vishrantwadi to Mumbai Cab Price","Dhanori to Mumbai Cab Service"],
["Vishrantwadi to Mumbai Airport Cab","Vishrantwadi to Dadar Cab"],
["Mumbai to Vishrantwadi Cab","Bhosari to Mumbai Cabs"],
["Bhosari to Mumbai Cab Service","Cab Service in Dhanori"],
["Cab Service in Vishrantwadi","Taxi Service in Vishrantwadi"],
["Innova Crysta on Rent in Vishrantwadi","Innova Crysta Hire in Bhosari"],
["Ertiga on Rent in Vishrantwadi","Sedan Car on Rent in Bhosari"],
["Cab Service in Pune","Pune to Mumbai Airport Cab"],
["Pune Mumbai Cab","Tingre Nagar to Mumbai Cabs"],
["Charholi to Mumbai Cab Service","Cab Service in Vishrantwadi Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Wide Coverage Across Vishrantwadi & Nearby Areas",
    WhyChoosedescription: "SRS Cab Service provides reliable cab services across Vishrantwadi, Dhanori, Tingre Nagar, Charholi, Bhosari, and nearby areas for local and Mumbai travel."
  },
  {
    WhyChooseheading: "Affordable Mumbai Cab Pricing",
    WhyChoosedescription: "We offer budget-friendly cab services from Vishrantwadi and nearby locations to Mumbai with transparent pricing including tolls and driver charges."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Vishrantwadi to Mumbai cab bookings, airport transfers, and local city travel."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options Available",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for all travel needs."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "We provide clean, well-maintained, and air-conditioned vehicles ensuring a smooth and comfortable journey."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "We offer flexible one-way cab service, round-trip bookings, and airport drop services from Pune to Mumbai."
  },
  {
    WhyChooseheading: "Doorstep Pickup Anywhere",
    WhyChoosedescription: "We provide pickup from homes, offices, hotels, and societies in Vishrantwadi, Dhanori, Bhosari, and all Pune areas."
  },
  {
    WhyChooseheading: "Trusted Cab Service Provider",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune and Mumbai routes due to punctual service, professional drivers, and affordable pricing."
  }
]
}

const faqData = [
  { question: "What is Vishrantwadi to Mumbai cab price?", answer: "Cab fare from Vishrantwadi to Mumbai typically starts from ₹1800–₹2600 for sedan depending on timing and availability." },
  { question: "Do you provide Dhanori to Mumbai cab service?", answer: "Yes, SRS Cab Service offers reliable cab services from Dhanori to Mumbai." },
  { question: "Do you provide Vishrantwadi to Mumbai airport cab?", answer: "Yes, we provide Mumbai Airport drop services including T1 and T2 terminals." },
  { question: "Can I book Vishrantwadi to Dadar cab?", answer: "Yes, we provide cab services from Vishrantwadi to Dadar and all Mumbai locations." },
  { question: "Do you provide Mumbai to Vishrantwadi cab?", answer: "Yes, we offer return cab services from Mumbai to Vishrantwadi." },
  { question: "Do you provide Bhosari to Mumbai cab service?", answer: "Yes, we provide cab services from Bhosari to Mumbai with one-way and round-trip options." },
  { question: "Which vehicles are available for rent?", answer: "We offer sedan cars, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Do you provide Innova Crysta on rent in Vishrantwadi?", answer: "Yes, premium Innova Crysta vehicles are available for rent in Vishrantwadi and nearby areas." },
  { question: "Can I book cab service in Vishrantwadi and Dhanori?", answer: "Yes, we provide local cab services in Vishrantwadi, Dhanori, and across Pune." },
  { question: "Is Pune to Mumbai airport cab available?", answer: "Yes, we provide reliable Pune to Mumbai Airport cab services 24/7." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sagar Jadhav",
    feedback:
      "Booked cab from Vishrantwadi to Mumbai Airport. Very smooth journey and affordable pricing.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Riya Kulkarni",
    feedback:
      "Best cab service in Vishrantwadi. Clean car, on-time pickup, and professional driver.",
    rating: 5
  }
];





















const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Vishrantwadi to Mumbai Cabs | SRS Cab Service",
  "description": "Reliable cabs from Vishrantwadi, Pune to Mumbai including Dadar, Mumbai Airport, Dhanori, Bhosari, Tingre Nagar, and Charholi. Book Innova, Ertiga, and Sedan cabs for one-way or round trips at affordable fares.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Vishrantwadi",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411015",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5734",
    "longitude": "73.9143"
  },
  "url": "https://www.srscabservice.com/vishrantwadi-to-mumbai-cab",
  "areaServed": ["Vishrantwadi", "Dhanori", "Bhosari", "Tingre Nagar", "Charholi", "Dadar", "Mumbai Airport"],
  "openingHours": "Mo-Su 00:00-23:59",
  "priceRange": "₹₹",
  "serviceType": [
    "Vishrantwadi to Mumbai Cab",
    "Airport drop and pickup",
    "One-way and round-trip cabs",
    "Innova, Ertiga, and Sedan cab hire"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "520"
  }
};






  return (
    <div>
      

<Helmet>
  <title>Vishrantwadi to Mumbai Cabs | SRS Cab Service</title>
  <meta 
    name="description" 
    content="Book cabs from Vishrantwadi, Pune to Mumbai including Dadar, Mumbai Airport, Dhanori, Bhosari, Tingre Nagar, and Charholi. Affordable Innova, Ertiga, and Sedan cabs for one-way and round trips. Reserve online now."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/79.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Vishrantwaditomuumbaicab;